"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../types/tape-builder-base");
exports.artifactType = 'internalRepaymentTape';
// Zod schema and new config type
exports.NodeConfigSchema = zod_1.z
    .object({
    rawRepaymentTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Slug for the raw repayment tape artifact'),
    generatedRepaymentTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Slug for the generated repayment tape artifact'),
    masterLoanTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Slug for the master loan tape artifact'),
})
    .describe('Configuration for internalRepaymentTape node');
// Zod schema and new node type
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    loanProductSlug: zod_1.z.string(),
    creditFacilitySlug: zod_1.z.string().nullable(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map